import React from 'react';
import PropTypes from 'prop-types';
import every from 'lodash/every';

// import { compose, fromPairs, map } from 'ramda';

import { FilterControl, FilterList } from 'containers';

const createFilter = middlewares => currentFilters => item =>
  every(middlewares.map(({ name, rule, defaultValue }) => rule(
      typeof currentFilters[name] === 'undefined' ? defaultValue : currentFilters[name],
      item,
    )));

const Filter = ({
  middlewares = [],
  items,
  renderItem,
  filter,
  departureId,
  ...props
}) => (
  <div>
    <FilterControl
      px={2}
      py={1}
      filter={filter}
      middlewares={middlewares}
      departureId={departureId}
      {...props}
    />
    <FilterList
      {...props}
      filter={filter}
      filterFunc={createFilter(middlewares)}
      items={items}
      renderItem={renderItem}
    />
  </div>
);
Filter.propTypes = {
  filter: PropTypes.string.isRequired,
  departureId: PropTypes.string,
  defaultFilter: PropTypes.string,
  middlewares: PropTypes.array,
  items: PropTypes.array,
  renderItem: PropTypes.func,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
};

export default Filter;



// WEBPACK FOOTER //
// ./src/components/organisms/Filter/index.js